import { render, staticRenderFns } from "./CustomUserList.vue?vue&type=template&id=5d4c8e9a&"
import script from "./CustomUserList.vue?vue&type=script&lang=js&"
export * from "./CustomUserList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports